(() => {
  /*
   * Renders a panel impressions to impressions ratio chart
   */
  angular
    .module('app.components')
    .directive('eventTimelineChart', ['$sce', 'EventsService',
      function ($sce, EventsService) {
        var weekLabels;

        return {
          restrict: "E",
          scope: {
            data: '=',
            forceUpdate: '@',
          },
          templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/charts/eventTimelineChart.html'),
          link: function (scope) {
            scope.$watch('forceUpdate', function () {
              scope.updateData(scope.data);
            }, true);

            scope.$watch('data', function (value) {
              scope.updateData(value);
            }, true);

            scope.updateData = function (value) {
              weekLabels = _.pluck(_.values(scope.data[0].weeklyEventCount), 'week');

              if (value) {
                scope.eventTypes = EventsService.generateEnrichedEventData(value);

                if (scope.firstEvent && scope.secondEvent) {
                  scope.eventTypes.forEach(function(event, index) {
                    if (scope.eventTypes[index].eventType === scope.firstEvent.eventType ||
                      scope.eventTypes[index].eventType === scope.secondEvent.eventType) {
                        scope.eventTypes[index].disabled = true;
                      } else {
                        scope.eventTypes[index].disabled = false;
                      }
                    });

                    // live data update
                    scope.firstEvent = value.filter(function (event) {
                      return event.eventType === scope.firstEvent.eventType;
                    })[0];
                    scope.secondEvent = value.filter(function (event) {
                      return event.eventType === scope.secondEvent.eventType;
                    })[0];
                  } else {
                    scope.eventTypes[0].disabled = true;
                    scope.eventTypes[1].disabled = true;
                    scope.firstEvent = scope.eventTypes[0];
                    scope.secondEvent = scope.eventTypes[1];
                  }

                  scope.refreshData(scope.firstEvent, scope.secondEvent);
                }
            }

            scope.updateEvent = function (whichEvent, newEvent) {
              newEvent.disabled = true;
              if (whichEvent == 'first') {
                scope.firstEvent.disabled = false;
                scope.firstEvent = newEvent;
              } else {
                scope.secondEvent.disabled = false;
                scope.secondEvent = newEvent;
              }
            }
          },
          // NOTE: DO NOT move the config options to the link function.
          // See : https://github.com/pablojim/highcharts-ng/issues/384
          controller: function ($scope) {
            // TODO: moving the refreshData function outside the chart
            // Config and reinitializing the options object every time disables pretty animations
            // TODO: ng-charts does not support dynamic y-axis yet so this is the only solution
            // I found for making the labels colored in the event color correctly
            $scope.refreshData = function (dataFirst, dataSecond) {
              if (angular.isUndefined(dataFirst) || angular.isUndefined(dataSecond)) return;

              $scope.config = {
                options: getChartCustomOptions(weekLabels, dataFirst, dataSecond),
                series: [{
                  name: dataFirst.name,
                  color: dataFirst.color,
                  data: _.pluck(_.values(dataFirst.weeklyEventCount), 'eventCount'),
                }, {
                  name: dataSecond.name,
                  color: dataSecond.color,
                  data: _.pluck(_.values(dataSecond.weeklyEventCount), 'eventCount'),
                  yAxis: 1
                }]
              };
            }
          }
        }
      }]);

  function renderRow(color, name, val) {
    return '<tr>' +
      '<td class="td-left">' +
        '<span class="bullet bullet-small" style="background-color: ' + color + ';"></span> ' +
        name + ': ' +
      '</td>' +
      '<td class="td-right">' + val.toLocaleString() + '</td>' +
    '</tr>';
  }

  function getChartCustomOptions(labels, dataFirst, dataSecond) {
    //using ChartService.getBaseChartConfig(); will mess the double yAxis
    return {
      chart: {
        zoomType: 'xy',
        type: 'areaspline',
        style: {
          fontFamily: 'Helvetica',
          fontSize: '11px'
        },
        spacingTop: 45
      },
      title: '',
      legend: {
        enabled: false,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        y: -50,
        floating: true,
        itemDistance: 20,
        borderWidth: 0,
        backgroundColor: '#FFFFFF',
        itemStyle: {
          color: '#889696',
          fontSize: '12px',
          fontWeight: 'normal'
        },
        symbolHeight: 8,
        symbolWidth: 8,
        symbolRadius: 5,
        symbolPadding: 10
      },
      tooltip: {
        shared: true,
        formatter: function () {
          var s = '<h4>week ' + labels[this.x] + '</h4>' +
          '<div class="highcharts-tooltip-outer">' +
            '<table class="highcharts-tooltip-inner">';
            angular.forEach(this.points, function (point) {
                s += renderRow(point.series.color, point.series.name, point.y);
            });
          s += '</table></div>';
          return s;
        },
        useHTML: true,
        borderRadius: 2,
        borderWidth: 0,
        borderColor: '#d4d4d4',
        backgroundColor: '#ffffff',
        shadow: false,
        valueDecimals: 2,
        style: {
          color: '#96a6a6',
          fontSize: '12px',
          padding: 0
        },
        crosshairs: {
          width: 1,
          color: '#5c6767'
        }
      },
      xAxis: {
        allowDecimals: false,
        gridLineColor: '#ededed',
        gridLineWidth: 1,
        minPadding: 0,
        maxPadding: 0,
        tickWidth: 0,
        lineWidth: 0,
        type: 'linear',
        labels: {
          y: 20,
          style: {
            color: '#5c6767'
          },
          formatter: function () {
            return `Week ${labels[this.value]}`;
          }
        }
      },
      yAxis: [{
        // Primary yAxis
        title: '',
        gridLineColor: '#ededed',
        showFirstLabel: false,
        labels: {
          x: -15,
          style: {
            color: dataFirst.color
          }
        }
      }, {
        // Secondary yAxis
        title: '',
        gridLineColor: '#ededed',
        showFirstLabel: false,
        labels: {
          align: 'right',
          style: {
            color: dataSecond.color
          }
        },
        gridLineWidth: 0,
        opposite: true,
        offset: -25
      }],
      credits: {
        enabled: false
      },
      plotOptions: {
        areaspline: {
          animation: !$('body').hasClass('pdf-export'),
          fillOpacity: 0.1,
          lineWidth: 3,
          marker: {
            lineWidth: 3,
            symbol: 'circle',
            radius: 5
          }
        }
      }
    };
  };
})();
